import { useTheme } from '@emotion/react';
import cn from 'classnames';

import { IConDefaultType } from '../types';

function ControlIcon({ className, size = 20, rotate, flip, color }: IConDefaultType) {
  const theme = useTheme();
  const fill = color || theme.color.icon.icon_3;

  return (
    <i
      className={cn('dds-icon', className, { flip })}
      style={{
        width: size,
        minWidth: size,
        height: size,
        transform: `rotate(${rotate}deg)`,
      }}
    >
      <svg xmlns="http://www.w3.org/2000/svg" width="16" height="16" viewBox="0 0 16 16" fill="none">
        <path
          d="M6.16699 9.33268C7.27156 9.33268 8.16699 10.2281 8.16699 11.3327C8.16699 12.4373 7.27156 13.3327 6.16699 13.3327C5.06242 13.3327 4.16699 12.4373 4.16699 11.3327C4.16699 10.2281 5.06242 9.33268 6.16699 9.33268Z"
          fill={fill}
        />
        <path
          d="M9.50033 2.66602C8.39576 2.66602 7.50033 3.56145 7.50033 4.66602C7.50033 5.77058 8.39576 6.66601 9.50033 6.66601C10.6049 6.66601 11.5003 5.77058 11.5003 4.66602C11.5003 3.56145 10.6049 2.66602 9.50033 2.66602Z"
          fill={fill}
        />
        <path
          d="M5.83366 4.13836C6.1098 4.13836 6.33366 4.36222 6.33366 4.63836C6.33366 4.9145 6.1098 5.13836 5.83366 5.13836L1.16699 5.13836C0.890849 5.13836 0.666992 4.9145 0.666992 4.63836C0.666992 4.36222 0.890849 4.13836 1.16699 4.13836H5.83366Z"
          fill={fill}
        />
        <path
          d="M9.83366 10.805C9.55752 10.805 9.33366 11.0289 9.33366 11.305C9.33366 11.5812 9.55752 11.805 9.83366 11.805H14.5003C14.7765 11.805 15.0003 11.5812 15.0003 11.305C15.0003 11.0289 14.7765 10.805 14.5003 10.805H9.83366Z"
          fill={fill}
        />
        <path
          d="M0.666992 11.305C0.666992 11.0289 0.89085 10.805 1.16699 10.805H2.50033C2.77647 10.805 3.00033 11.0289 3.00033 11.305C3.00033 11.5812 2.77647 11.805 2.50033 11.805H1.16699C0.89085 11.805 0.666992 11.5812 0.666992 11.305Z"
          fill={fill}
        />
        <path
          d="M14.5003 4.13836C14.7765 4.13836 15.0003 4.36222 15.0003 4.63836C15.0003 4.9145 14.7765 5.13836 14.5003 5.13836L13.167 5.13836C12.8908 5.13836 12.667 4.9145 12.667 4.63836C12.667 4.36222 12.8908 4.13836 13.167 4.13836H14.5003Z"
          fill={fill}
        />
      </svg>
    </i>
  );
}

export default ControlIcon;
